__turbopack_context__.v({
  "animateText": "style-module-scss-module__kbEitW__animateText",
  "cLoaderTriangle": "style-module-scss-module__kbEitW__cLoaderTriangle",
});
